<nz-modal
  [(nzVisible)]="isVisibleGeneratePagingBoardModal"
  [nzTitle]="modalTitleOfRental"
  [nzContent]="modalContentOfRental"
  [nzFooter]="modalFooterOfRental"
  (nzOnCancel)="handleCancelGeneratePagingBoardModal()"
  nzClosable="false"
>
  <ng-template #modalTitleOfRental>
    <div class="flex justify-between items-center my-4">
      <h4>Paging Board</h4>
      <div class="flex max-[400px]:flex-col gap-2">
        <button nz-button nzType="primary" [disabled]="pagingBoardForm.invalid" (click)="pagingBoardFormSave()">Save</button>
        <button nz-button nzType="primary" [disabled]="isDirtyOrInvalid()" (click)="loadPagingBoard('preview')">Preview</button>
      </div>
    </div>
  </ng-template>

  <ng-template #modalContentOfRental>
    <div *ngIf="loading">
      <p class="loading-tag">Data Loading ...</p>
    </div>
    <div *ngIf="!loading">
      <div *ngIf="pdfLoading" class="my-4">
        <p class="loading-tag">Report Generating ....</p>
      </div>
      <div *ngIf="!pdfLoading" class="my-4">
        <form nz-form [formGroup]="pagingBoardForm" [nzLayout]="'vertical'">
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="customer" nzRequired>Customer Name</nz-form-label>
            <nz-form-control [nzErrorTip]="customerNameError">
              <input nz-input class="w-full" type="text" formControlName="customer" placeholder="Enter Name"/>
            </nz-form-control>
            <ng-template #customerNameError>
              <span *ngIf="pagingBoardErrors?.customer?.required">Please enter customer name. </span>
              <span *ngIf="pagingBoardErrors?.customer?.wordLimit">Only allowed 2 words with 15 characters. </span>
            </ng-template>
          </nz-form-item>
          <!-- <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="vehicleCategory" nzRequired>Vehicle Category</nz-form-label>
            <nz-form-control [nzErrorTip]="vehicleCategoryError">
              <input nz-input class="w-full" type="text" formControlName="vehicleCategory" placeholder="Enter Category"/>
            </nz-form-control>
            <ng-template #vehicleCategoryError></ng-template>
          </nz-form-item> -->
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="date" nzRequired>{{pagingBoardData?.type}} Date</nz-form-label>
            <nz-form-control [nzErrorTip]="dateError">
              <nz-date-picker class="w-full" formControlName="date"></nz-date-picker>
            </nz-form-control>
            <ng-template #dateError>
              <span *ngIf="pagingBoardErrors?.date?.required">Please select date. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="time" nzRequired>{{pagingBoardData?.type}} Time</nz-form-label>
            <nz-form-control [nzErrorTip]="timeError">
              <nz-time-picker nzPlaceHolder="Select Time" class="w-full" formControlName="time"   [nzFormat]="'HH:mm'"></nz-time-picker>
            </nz-form-control>
            <ng-template #timeError>
              <span *ngIf="pagingBoardErrors?.time?.required">Please select time. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="flight" nzRequired>{{pagingBoardData?.type}} Flight Number</nz-form-label>
            <nz-form-control [nzErrorTip]="flightError">
              <input nz-input class="w-full" type="text" formControlName="flight" placeholder="Enter Flight"/>
            </nz-form-control>
            <ng-template #flightError>
              <span *ngIf="pagingBoardErrors?.flight?.required">Please enter flight name. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="dropLocation">Drop Off Location</nz-form-label>
            <nz-form-control [nzErrorTip]="dropLocationError">
              <input nz-input class="w-full" type="text" formControlName="dropLocation" placeholder="Enter Location"/>
            </nz-form-control>
            <ng-template #dropLocationError>
              <span *ngIf="pagingBoardErrors?.dropLocation?.required">Please enter location. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="numOfPax">Number of Pax</nz-form-label>
            <nz-form-control [nzErrorTip]="nuOfPaxError">
              <input nz-input class="w-full" type="number" [min]="0" formControlName="numOfPax" placeholder="Enter Number Of Pax"/>
            </nz-form-control>
            <ng-template #nuOfPaxError>
              <span *ngIf="pagingBoardErrors?.numOfPax?.required">Please enter count. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="customerNumber" nzRequired>Contact Number</nz-form-label>
            <nz-form-control [nzErrorTip]="customerNumberError">
              <input nz-input class="w-full" type="text" formControlName="customerNumber" placeholder="Enter Number"/>
            </nz-form-control>
            <ng-template #customerNumberError>
              <span *ngIf="pagingBoardErrors?.customerNumber?.required">Please enter number. </span>
              <span *ngIf="pagingBoardErrors?.customerNumber?.maxlength"> Maximum length is 15 characters.</span>
              <span *ngIf="pagingBoardErrors?.customerNumber?.pattern">Only allowed numbers, please avoid adding special characters or letters.</span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="agent">Agent Name</nz-form-label>
            <nz-form-control [nzErrorTip]="agentError">
              <input nz-input class="w-full" type="text" formControlName="agent" placeholder="Enter Agent Name"/>
            </nz-form-control>
            <ng-template #agentError></ng-template>
          </nz-form-item>
        </form>
      </div>
    </div>
  </ng-template>

  <ng-template #modalFooterOfRental>
    <div class="flex max-[400px]:flex-col justify-between items-center gap-2 my-4">
      <button nz-button nzType="default" class="max-[400px]:order-last max-[400px]:w-full cancel-btn" (click)="handleCancelGeneratePagingBoardModal()">Cancel</button>
      <div class="flex gap-2">
        <button nz-button nzType="default" class="outline-button" [disabled]="isDirtyOrInvalid()" (click)="loadPagingBoard('download')">Download</button>
        <button nz-button nzType="default" class="outline-button" [disabled]="isDirtyOrInvalid()" (click)="loadPagingBoard('email')">Send</button>
        <button nz-button nzType="default" class="outline-button" [disabled]="isDirtyOrInvalid()" (click)="loadPagingBoard('print')">Print</button>
      </div>
    </div>
  </ng-template>
</nz-modal>
